import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import cn from 'classnames';

import { IProgramCodeListProps } from './ProgramCodeList.interface';

import './style.scss';

const activeIcon = <CheckBox color="primary" />;
const inactiveIcon = <CheckBoxOutlineBlank color="primary" />;

const ProgramCodeList: FC<IProgramCodeListProps> = ({ data, activeId, onClick }) => {
  const { t } = useTranslation();

  return (
    <div className="program-code-list">
      <div className="program-code-list__header">
        <div className="program-code-list__cell">{t('admin.programCode')}</div>
        <div className="program-code-list__cell">{t('admin.active')}</div>
      </div>

      {data.map(item => (
        <div
          className={cn('program-code-list__row', {
            'program-code-list__row_active': item.id === activeId,
          })}
          onClick={() => onClick(item.id)}
          key={item.id}
        >
          <div className="program-code-list__cell">{item.name}</div>
          <div className="program-code-list__cell">
            <div
              className={cn('program-code-list__checkbox', {
                'program-code-list__checkbox_active': item.isActive,
                'program-code-list__checkbox_inactive': !item.isActive,
              })}
            >
              {item.isActive ? activeIcon : inactiveIcon}
              {item.isActive ? t('admin.active') : t('admin.inactive')}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProgramCodeList;
